import React, { useState, useEffect, useMemo } from "react";
import DatePicker from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
// import { utils } from 'react-modern-calendar-datepicker';
import moment from "moment-jalaali";

// import DatePicker from "react-datepicker";
import { useLang } from "../../../i18n/Metronici18n";
import { useFormikContext } from "formik";
import {
  formatDateString,
  convertDateStringToLocal,
  initDatePickerValue,
} from "../../../_helpers/DateFormaterHelpers";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }
  if (touched && !errors) {
    classes.push("is-valid");
  }
  return classes.join(" ");
};


export function DatePickerField(props) {
  const { setFieldValue, errors, touched } = useFormikContext();
  const { field } = props;
  const locale = useLang();
  const [selectedDay, setSelectedDay] = useState(null);
  const [onSelected, setOnSelected] = useState(0);
  const tdOnClick = (index) => {
    setOnSelected(index);
  };

  // useEffect(() => {
  //   if (field.value) {
  //     var date = convertDateStringToLocal(field.value, locale)
  //     var d = new Date(date),
  //       month = "" + (d.getMonth() + 1),
  //       day = "" + d.getDate(),
  //       year = d.getFullYear();
  //     setSelectedDay({
  //       day: day,
  //       month: month,
  //       year: year,
  //     });
  //   }

  // }, [field.value]);

  const setDatepickerValue = ({
    val,
    field,
    locale,
    setFieldValue,
  }) => {

    let utcDate = null;
    if (locale === "fa") {
      utcDate = moment(`${val.year}/${val.month}/${val.day}`, "jYYYY/jM/jD");
    } else {
      utcDate = moment(`${val.year}-${val.month}-${val.day}`, "YYYY-MM-DD");
    }
    let newValue = utcDate.format("YYYY-MM-DDTHH:mm:ss");
    setFieldValue(field.name, newValue);
    setSelectedDay();
    if (props.onChange) {
      props.onChange()
    }
  };


  const renderCustomInput = ({ ref }) => (
    <input
      ref={ref} // necessary
      // placeholder="I'm a custom input"
      value={field.value ? convertDateStringToLocal(field.value, locale) : null}
      style={{
        // width: "100%",
        // fontSize: "1.5rem"
        // display: "block"
      }}
      className={getFieldCSSClasses(touched[field.name], errors[field.name])}
    // wrapperClassName="datepicker"
    // className='date-input-field'
    />
  )

  // const renderCustomInputFilter = ({ ref }) => (
  //   <input
  //     ref={ref} // necessary
  //     // placeholder="I'm a custom input"
  //     value={selectedDay}
  //     style={{
  //       width: "100%"
  //     }}
  //     className={getFieldCSSClasses(touched[field.name], errors[field.name])}
  //   />
  // )

  const minimumDateEn = {
    year: 2021,
    month: 3,
    day: 21
  };

  const minimumDateFa = {
    year: 1400,
    month: 1,
    day: 1
  };

  return (
    <>
      {props.label && <label>{props.label}</label>}
      <div
        style={{ position: "relative", zIndex: props.rowIdx === onSelected && "999" }}
        onClick={() => tdOnClick(props.rowIdx)}
      >
        <DatePicker
          {...field}
          {...props}
          locale={locale}
          isRtl={locale == "en" ? false : true}
          // minimumDate={locale == "en" ? minimumDateEn : minimumDateFa}
          // colorPrimary="#be9a57"
          // calendarPopperPosition="bottom"
          // formatInputText="YYYY/MM/DD"
          value={selectedDay}
          // onChange={setSelectedDay}
          onChange={(val) => {
            setDatepickerValue({
              val,
              field,
              locale,
              setFieldValue,
            });
          }}
          shouldHighlightWeekends
          renderInput={renderCustomInput} // render a custom input
          calendarClassName="responsive-calendar"
        // renderInput={props.label ? renderCustomInput : renderCustomInputFilter} // render a custom input
        />
      </div>
      {errors[field.name] && touched[field.name] ? (
        <div className="invalid-datepicker-feedback">
          {errors[field.name].toString()}
        </div>
      ) : (
        <div className="feedback">
          {/* Please enter <b>{props.label}</b> in 'mm/dd/yyyy' format */}
        </div>
      )}

    </>
  );
}
